import { QuoteMessages } from './quote.messages.ts';
import { OrderMessages } from './order.messages.ts';
import { CompanyMessages } from './company.messages.ts';
import { AddressMessages } from './address.messages.ts';
import { ContactMessages } from './contact.messages.ts';
import { DeviceQrMessages } from './device-qr.messages.ts';
import { HomeMessages } from './home.messages.ts';

const nl = {
  back: 'Terug',
  continue: 'Volgende',
  copyright: '© {year} {productName}. Alle rechten voorbehouden.',
  error: {
    sendBack: 'Stuur me terug',
    notFound: 'Sorry, we kunnen de pagina die je zoekt niet vinden.',
    unexpected: 'Oeps! Er ging iets mis. Onze experts zijn er mee bezig.',
    help: 'Voor hulp kan je ons bellen op',
  },
  home: HomeMessages,
  quantity: 'Aantal',
  submit: 'Verstuur',
  total: 'Totaal',
  website: 'Website',

  address: AddressMessages,
  company: CompanyMessages,
  contact: ContactMessages,
  deviceQr: DeviceQrMessages,
  order: OrderMessages,
  quote: QuoteMessages,
};

export default nl;
